import Maintenance from '@/agilis/components/Maintenance/Maintenance.vue'
import AppDashboard from '@/agilis/components/AppDashboard/AppDashboard.vue'
import { mapGetters } from 'vuex'
import ConfigurationDashboard from '../../agilis/util/ConfigurationDashboard'

export default {
  name: 'Dashboard',

  components: {
    Maintenance,
    AppDashboard
  },

  computed: {
    ...mapGetters({
      'applicationMaintenance': 'contextStore/applicationMaintenance',
      'applicationId': 'contextStore/applicationId',
      'workspaceId': 'contextStore/workspaceId'
    }),

    context () {
      if (this.workspaceId) {
        return ConfigurationDashboard.getWorkspaceDashboardContext(this.applicationId, this.workspaceId)
      }
      return ConfigurationDashboard.getAppDashboardContext(this.applicationId)
    }
  }
}
